<script>
export default {
    name: 'IlluCoursLive',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-cours-live"
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 64 64"
    >
        <path fill="none" d="M0 0h64v64H0z" />
        <circle
            cx="1.168"
            cy="1.168"
            r="1.168"
            :fill="primaryColor"
            class="primary-color"
            transform="translate(30.831 13.191)"
        />
        <g transform="translate(23.5 18.147)">
            <g>
                <path
                    d="M31.669 16.937a4.306 4.306 0 014.306 4.306v1.076a4.3 4.3 0 01-4.306 4.3 4.3 4.3 0 01-4.306-4.3v-1.076a4.306 4.306 0 014.306-4.306z"
                    fill="none"
                    :stroke="secondaryColor"
                    class="secondary-color"
                    transform="translate(-23.169 -16.937)"
                />
                <path
                    d="M39.147 39.082c0-4.7-3.805-9.394-8.5-9.394s-8.5 4.7-8.5 9.394 17 4.696 17 0z"
                    fill="none"
                    :stroke="secondaryColor"
                    class="secondary-color"
                    transform="translate(-22.147 -18.637)"
                />
            </g>
            <path
                :fill="primaryColor"
                class="primary-color"
                fill-rule="evenodd"
                d="M31.786 32.145A2.694 2.694 0 0029 34.737V40.5h2.012v-2.3h1.546v2.3h2.01v-5.763a2.692 2.692 0 00-2.782-2.592zm-.773 4.32v-1.728a.775.775 0 011.546 0v1.728z"
                transform="translate(-23.286 -18.813)"
            />
        </g>
        <g transform="translate(8.021 12)">
            <path
                fill="none"
                :stroke="secondaryColor"
                class="secondary-color"
                stroke-linecap="square"
                stroke-width=".5"
                d="M.282 4.411h47.394"
            />
            <path
                d="M0 0v5.427"
                fill="none"
                :stroke="secondaryColor"
                class="secondary-color"
                transform="translate(26.755 31.994)"
            />
            <path
                d="M0 5.427V0"
                fill="none"
                :stroke="secondaryColor"
                class="secondary-color"
                transform="translate(21.202 31.994)"
            />
            <path
                d="M0 0h24.084v2.579H0z"
                fill="none"
                :stroke="secondaryColor"
                class="secondary-color"
                transform="translate(11.937 37.421)"
            />
            <path
                d="M7.477 40.854h41.415s3.082 0 3.082-2.625V11.673a2.637 2.637 0 00-2.859-2.808H6.809a2.609 2.609 0 00-2.79 2.808v25.883a3.119 3.119 0 003.458 3.298z"
                fill="none"
                :stroke="secondaryColor"
                class="secondary-color"
                transform="translate(-4.016 -8.863)"
            />
        </g>
    </svg>
</template>
